import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { PAYMENT_METHOD } from '../../../constant'
import { changeDisableOrder } from '../../../store/slice'

export const PostPaid = ({ isBlock }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!isBlock) {
      dispatch(
        changeDisableOrder({
          [PAYMENT_METHOD.POST_PAID]: true,
        }),
      )
    }

    return () => {
      dispatch(
        changeDisableOrder({
          [PAYMENT_METHOD.POST_PAID]: false,
        }),
      )
    }
  }, [isBlock])

  return (
    <>
      {!isBlock ? (
        <Element style={{ color: '#9C9C9C' }}>
          <Translate value="cartAndOrders.message.m042" />
        </Element>
      ) : (
        <></>
      )}
    </>
  )
}
